const NotFound = () => {
    
    return ( 
        <div className="not-found">
            <h2>404 : Page Not Found!</h2>
        </div>
     );
}
 
export default NotFound;